import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, errMsg, fmtDate, CATEGORY_LABEL } from "@/lib/api";

const PRINT_CSS = "@media print { .no-print { display: none !important; } .grain::before, .grain::after { display: none !important; } body { background: #fff !important; } @page { margin: 14mm; } }";

const Address = ({ o }) => {
  const a = o.shippingAddress;
  const lines = [`${a.firstName} ${a.lastName}`, a.addressLine1, a.addressLine2, [a.city, a.state, a.postCode].filter(Boolean).join(" "), o.countryName];
  return (
    <div className="border-2 border-[#1A1A1A] p-8" data-testid="slip-address">
      <p className="text-[11px] uppercase tracking-[0.3em] text-[#5A626A]">Ship to</p>
      <div className="mt-4 text-2xl leading-snug">{lines.filter(Boolean).map((l, i) => <p key={i} className={i === 0 ? "font-medium" : ""}>{l}</p>)}</div>
      {a.phone && <p className="mt-4 text-sm">Phone: {a.phone}</p>}
    </div>
  );
};

export default function PackingSlip() {
  const { id } = useParams();
  const [o, setO] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get(`/admin/orders/${id}`).then((r) => setO(r.data)).catch((e) => setErr(errMsg(e)));
  }, [id]);

  if (err) return <p className="p-10 text-sm" data-testid="slip-error">{err}</p>;
  if (!o) return <p className="p-10 text-sm">Loading…</p>;
  return (
    <div className="mx-auto max-w-[720px] bg-white p-10 text-[#1A1A1A]" data-testid="packing-slip">
      <style>{PRINT_CSS}</style>
      <div className="no-print mb-8 flex justify-end">
        <button className="btn-primary" onClick={() => window.print()} data-testid="slip-print-btn">Print packing slip</button>
      </div>
      <div className="flex items-end justify-between border-b border-[#1A1A1A] pb-5">
        <div>
          <p className="text-[15px] tracking-[0.42em]">LASZLO ABONYI</p>
          <p className="mt-1 text-xs text-[#5A626A]">laszloabonyi.com</p>
        </div>
        <div className="text-right text-sm">
          <p>Order <strong data-testid="slip-ref">{o.ref}</strong></p>
          <p className="text-[#5A626A]">{fmtDate(o.paidAt || o.createdAt)}</p>
        </div>
      </div>
      <div className="mt-8"><Address o={o} /></div>
      <table className="mt-10 w-full text-sm" data-testid="slip-items">
        <thead><tr className="border-b border-[#1A1A1A] text-left text-[10px] uppercase tracking-[0.2em]"><th className="py-2">Item</th><th>Type</th><th className="text-right">Qty</th></tr></thead>
        <tbody>
          {o.items.map((i, n) => (
            <tr key={n} className="border-b border-[#E5E0D8]">
              <td className="py-3">{i.title}</td>
              <td>{CATEGORY_LABEL[i.category]}{i.isOriginal ? "" : ` · ${i.variantLabel}`}</td>
              <td className="text-right">{i.quantity}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {o.giftMessage && (
        <div className="mt-10 border border-[#8C7A5B] p-6" data-testid="slip-gift-message">
          <p className="text-[11px] uppercase tracking-[0.3em] text-[#5A626A]">Gift message</p>
          <p className="mt-3 whitespace-pre-line font-display text-xl italic">{o.giftMessage}</p>
        </div>
      )}
      <p className="mt-12 font-display text-xl italic">Thank you for supporting independent art.</p>
    </div>
  );
}
